import React, { useEffect, useRef, useCallback } from "react";
import images from "../../images";

const CustomInputProps = React.memo(
  ({
    value = "",
    onChange,
    placeholder,
    iconImage,
    countryCode,
    isCurrencyInput = false,
    error = "",
    iconDropdown,
    classNameInput,
  }) => {
    const inputRef = useRef(null);
    const formatInput = useCallback(
      (input) => {
        if (isCurrencyInput) {
          const cleaned = input.replace(/[^0-9.]/g, "");
          return cleaned;
        } else {
          const cleaned = input.replace(/[^0-9]/g, "");
          return cleaned;
        }
      },
      [isCurrencyInput]
    );

    const handleInputChange = useCallback(
      (e) => {
        const formattedInput = formatInput(e.target.value);
        onChange(formattedInput);
      },
      [onChange, formatInput]
    );

    useEffect(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, [value]);

    return (
      <div
        className={`flex h-[50px] items-center bg-white rounded-lg px-3 py-2 border ${
          error
            ? "border-[#EF4056] focus-within:border-[#EF4056]"
            : "border-[#E9E6E4] focus-within:border-[#A0A0A0]"
        }  focus-within:border-1 transition-colors duration-200`}
      >
        <div className="flex gap-[6px] w-auto h-full items-center border-r pr-2">
          <div className=" w-6 h-6 flex-shrink-0">
            <img
              src={iconImage || images.WhatsappIconWhite}
              alt="Icon"
              className="w-6 h-6 object-contain "
            />
          </div>
          {countryCode && (
            <div className="text-[#A0A0A0] font-medium text-sm ">
              {countryCode}
            </div>
          )}
          {iconDropdown && (
            <div className="w-3 h-3 flex-shrink-0">
              <img
                src={iconDropdown}
                alt=""
                className="w-full h-full object-contain"
              />
            </div>
          )}
        </div>
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={handleInputChange}
          // onChange={handleChange}
          className={`outline-none w-full bg-transparent placeholder:text-[#A0A0A0]  ml-2 focus:outline-none ${
            classNameInput || "text-[#333333]"
          }`}
          placeholder={placeholder || ""}
        />
      </div>
    );
  }
);

export default CustomInputProps;
